import { incotermsSendedService } from "@/_services";
export const incotermSended = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getIncotermsRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getIncotermsSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getIncotermsError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
  },
  actions: {
    getIncoterms({ commit }, request) {
      commit("getIncotermsRequest");
      incotermsSendedService
        .getIncoterms(request.pagination, request.filters)
        .then((response) => {
          commit("getIncotermsSuccess", response);
        })
        .catch((error) => {
          commit("getIncotermsError", error);
        });
    },
  },
};
